export const findLastSequentialIndex = <T>(
  items: T[],
  startIndex: number,
  getItemNumberFunc: (item: T) => number,
) => {
  const getItemNumber = (item: T) => {
    const itemNumber = getItemNumberFunc(item);
    if (typeof itemNumber !== 'number') {
      throw new Error(`getItemNumberFunc has to return number.`)
    }
    return itemNumber;
  }

  let lastItemNumber = getItemNumber(items[startIndex]);

  for (let i = startIndex + 1; i < items.length; i++) {
    const itemNumber = getItemNumber(items[i]);

    if (lastItemNumber === -1 || itemNumber - 1 === lastItemNumber) {
      lastItemNumber = itemNumber;
    } else {
      return i - 1;
    }
  }

  return items.length - 1;
}
